import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-cream px-5 py-16 sm:px-8 lg:py-20" data-id="element-75" data-mp="1o2vk0ww891a9">
      <motion.div initial={{
      opacity: 0,
      y: 22
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-60px'
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="mx-auto flex max-w-4xl flex-col items-start gap-6 rounded-3xl border border-forest/12 bg-cream-card p-7 shadow-soft sm:flex-row sm:items-center sm:p-10" data-id="element-76" data-mp="223oe5gim9ucu">
        <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-forest text-cream" aria-hidden="true" data-id="element-77" data-mp="1j52c9zf9zz7v">
          <ShieldCheckIcon className="h-8 w-8" strokeWidth={1.8} data-id="element-78" data-mp="1ebr1jn7ceyao" />
        </span>
        <div data-id="element-79" data-mp="qmooytrkfvn1">
          <h2 className="font-display text-2xl leading-tight text-forest-dark sm:text-3xl" data-id="element-80" data-mp="qm6i737a1z0v">
            Garantía 7 días — sin preguntas
          </h2>
          <p className="mt-3 leading-relaxed text-forest-dark/70" data-id="element-81" data-mp="p0b9g1gzbkil">
            Abrís los tomos. Los usás en tu cocina. Si en 7 días no es lo que
            esperabas: devolución del 100%, sin formularios, sin drama.
          </p>
          <p className="mt-3 text-sm font-semibold text-forest" data-id="element-82" data-mp="ypuqr2p1n6bc">
            Tasa de devoluciones: menos del 1%.
          </p>
        </div>
      </motion.div>
    </section>;
}